import { Badge, Flex, Icon } from '@chakra-ui/react';
import { BsStarFill } from 'react-icons/bs';

export interface FirstSaleBadgeProps {
  onClick?: () => void;
}

export default function FirstSaleBadge({ onClick }: FirstSaleBadgeProps) {
  return (
    <Badge
      padding="2px 4px"
      borderRadius={4}
      width={'fit-content'}
      height={'fit-content'}
      colorScheme='purple'
      onClick={onClick}
      cursor={onClick ? 'pointer' : ''}
    >
      <Flex direction="row" gap={1} alignItems="center">
        <Icon as={BsStarFill} w={3} h={3} />
        First Sale
      </Flex>
    </Badge>
  );
}
